const guides = [
  {
    icon: "ri-run-fill",
    title: "怎么抢前排",
    desc: "盯紧快讯流里的热乎标，看到想吃的直接开看，别等别人转手再发。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-sort-asc",
    title: "首发的门道",
    desc: "时间戳越新越靠前，首发按时间排，整点会自动重排本轮排序。",
    tone: "bg-accent-100 text-accent-800",
  },
  {
    icon: "ri-bell-line",
    title: "蹲更新的姿势",
    desc: "按题材进对应分区挂上蹲点，板块一有新料，你就能第一个看见。",
    tone: "bg-secondary-100 text-secondary-900",
  },
];

const nav = [
  { href: "#feed", label: "热乎快讯" },
  { href: "#comment", label: "评论区前排" },
  { href: "#rank", label: "今日热瓜榜" },
  { href: "#columns", label: "运营分区" },
];

export default function SiteFooter() {
  const backTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-10 px-4 py-12 md:px-6 md:py-14">
        {/* quick guide shell */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {guides.map((g) => (
            <div
              key={g.title}
              className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${g.tone}`}>
                <i className={`${g.icon} text-lg`} />
              </span>
              <div className="flex flex-col gap-1">
                <h5 className="text-sm font-extrabold text-foreground-950">{g.title}</h5>
                <p className="text-[13px] leading-relaxed text-foreground-700">{g.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="h-px bg-background-200" />

        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
          <div className="flex max-w-md flex-col gap-3">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-flashlight-fill" />
              </span>
              <span className="text-xl font-black tracking-tight text-foreground-950">
                吃瓜<span className="num text-primary-600">91</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-700">
              手速第一线的速递站，热乎瓜按时间排好给你，前排看点一屏给够，首发最快的地方。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="inline-flex cursor-pointer items-center whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs font-bold text-foreground-800 transition hover:border-primary-400 hover:text-primary-600"
              >
                {n.label}
              </a>
            ))}
            <button
              onClick={backTop}
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-xs font-bold text-background-50 transition hover:bg-foreground-800"
            >
              <i className="ri-arrow-up-line" /> 回到顶部
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-2 border-t border-background-200 pt-5 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 吃瓜91 · 第一线速递站，内容仅供信息展示，静态演示页。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-flashlight-fill text-accent-600" /> 每 30 秒自动轮换本轮首发
          </p>
        </div>
      </div>
    </footer>
  );
}